export default __webpack_public_path__ + "static/media/3.554d24c6.png";